import React, { RefObject, useEffect, useRef } from "react";

import { RestaurantItemType } from "../../../../api/types/restaurant.type";
import { useMap } from "../../../../store/map.context";
import { Position } from "..";
import RestaurantItem from "./Item";
import classes from "./list.module.scss";

interface Props {
  restaurants: RestaurantItemType[];
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpen?: () => void;
  position: Position;
  scrollIntoView?: boolean;
  inputRef: RefObject<HTMLInputElement>;
}
const keys = [
  "meta_title",
  "meta_description",
  "block_1_content",
  "block_1_image_desktop",
  "block_1_image_mobile",
  "block_2_content",
  "block_2_image_desktop",
  "block_2_image_mobile",
  "block_3_content",
  "block_4_item_1_title",
  "block_4_image_1_desktop",
  "block_4_image_1_mobile",
  "block_4_item_2_title",
  "block_4_image_2_desktop",
  "block_4_image_2_mobile",
  "block_4_item_3_title",
  "block_4_image_3_desktop",
  "block_4_image_3_mobile",
];
const RestaurantList = ({
  restaurants,
  setModalIsOpen,
  setIsOpen,
  position,
  scrollIntoView = false,
  inputRef,
}: Props) => {
  const { map } = useMap();

  const divRef = useRef<HTMLDivElement>(null);

  const checkAvailability = (index: number) => {
    for (const key in restaurants[index]) {
      if (keys.indexOf(key) !== -1) {
        if (!restaurants[index][key as keyof RestaurantItemType]) {
          return false;
        }
      }
    }
    return true;
  };

  useEffect(() => {
    if (map.id !== -1) {
      const elm = document.getElementById(map.id.toString());
      if (elm) elm.scrollIntoView({ block: "center", behavior: "smooth" });
    }
  }, [map.id]);

  useEffect(() => {
    if (scrollIntoView && position.lat !== 0 && position.lng !== 0)
      if (divRef.current) {
        divRef.current.scrollTop = 0;
      }
  }, [position, scrollIntoView]);

  return (
    <div
      className={classes.container}
      ref={divRef}
      id="restaurantsCardContainer"
    >
      {restaurants.map((restaurant, i) => (
        <RestaurantItem
          key={restaurant.id}
          ID={restaurant.id}
          name={restaurant.name}
          LAT={restaurant.latitude as number}
          LNG={restaurant.longitude as number}
          phone_number={restaurant.phone_number}
          location={restaurant.addresse}
          opening_hours={restaurant.opening_hours}
          closing_rules={restaurant.closing_rules}
          setModalIsOpen={setModalIsOpen}
          setIsOpen={setIsOpen}
          position={position}
          inputRef={inputRef}
          slug={restaurant.slug}
          available={checkAvailability(i)}
          isClosed={restaurant.closed}
          isActive={restaurant.active}
        />
      ))}
    </div>
  );
};

export default RestaurantList;
